angular.module('env.data.rest.model.modelDefinition', [])

    .factory('ModelDefinition', function (FieldDefinition) {

        var defaultModel = {
            idProperty: 'id',
            fields: {
                id: {}
            },
            validate: function () {
                return true;
            }
        };

        /**
         * Model definition
         * @param {string} modelDefinitionType unique type of model
         * @param {*} modelDefinitionConfiguration configuration of model
         * @param {*} allDefinitions all defined model definitions
         * @constructor
         */
        function ModelDefinition(modelDefinitionType, modelDefinitionConfiguration, allDefinitions) {
            var _this = this;

            var config;
            var fields;
            var errPrefix = _.str.sprintf("`%s` model definition error: ", modelDefinitionType);

            constructor();

            //region constructor

            /**
             * Isolated constructor
             */
            function constructor() {

                if (!modelDefinitionType || !_.isString(modelDefinitionType)) {
                    throw new Error(errPrefix + "model type must be set");
                }
                if (!modelDefinitionConfiguration) {
                    throw new Error(errPrefix + "model definition config must be set");
                }
                if (!allDefinitions) {
                    allDefinitions = [];
                }
                config = validateAndFixConfig(config);
                config = processParents(config);
                config = processFields(config);
                config = processCustomMethods(config);

                /**
                 * Validate config, fix missed fields, set default values
                 * @param {*} cfg - config
                 */
                function validateAndFixConfig(cfg) {

                    cfg = _.defaults(modelDefinitionConfiguration, defaultModel); // defaults
                    cfg.type = modelDefinitionType;

                    // region `extend` field

                    var extend = [];
                    if (cfg.extend) {
                        if (_.isArray(cfg.extend)) {
                            _.forEach(cfg.extend, function (el) {
                                if (_.isString(el)) {
                                    extend.push(el);
                                }
                            });
                        } else if (_.isString(cfg.extend)) {
                            extend.push(cfg.extend);
                        }
                    }
                    _.forEach(extend, function (el) {
                        if (!allDefinitions[el]) {
                            throw new Error(errPrefix + "not all parents was initialized");
                        }
                    });
                    cfg.extend = extend;

                    // endregion

                    return cfg;
                }

                function processParents(cfg) {
                    var oldExtend = cfg.extend.slice(0);
                    var params = [true, {}].concat(getParentConfigs(cfg), cfg);
                    cfg = $.extend.apply(null, params);
                    cfg.extend = oldExtend;
                    return cfg;
                }

                /**
                 * Get array of parent configs (in order of it's definition)
                 * @param cfg model definition config
                 */
                function getParentConfigs(cfg) {
                    var parentConfigs = [];
                    for (var i = 0; i < cfg.extend.length; i++) {
                        var parentConfig = allDefinitions[cfg.extend[i]].getConfig();
                        parentConfigs.push(parentConfig);
                    }
                    return parentConfigs.reverse();
                }

                function processFields(cfg) {
                    fields = [];
                    _.forEach(cfg.fields, function (fieldDefinition, filedName) {
                        fields.push(new FieldDefinition(filedName, fieldDefinition));
                    });
                    return cfg;
                }

                function processCustomMethods(cfg) {
                    var methods = {};
                    if (cfg.methods) {
                        _.forEach(cfg.methods, function (method, methodName) {
                            if (method && _.isFunction(method)) {
                                methods[methodName] = method;
                            }
                        });
                    }
                    cfg.methods = methods;
                    return cfg;
                }
            }

            //endregion

            //region Public interface

            /**
             * Get model definition name
             * @returns {string} unique model definition name
             */
            _this.getType = function () {
                return config.type;
            };

            /**
             * Get definition config
             * @returns {*}
             */
            _this.getConfig = function () {
                return config;
            };

            /**
             * Get field definitions
             * @returns {Array} array of FieldDefinition
             */
            _this.getFields = function () {
                return fields;
            };

            /**
             * Get route of current type
             * @returns {string}
             */
            _this.getUrl = function () {
                return config.url || config.type;
            };

            /**
             * Get name of the model identifier property (must be unique for current definition)
             * @returns {string}
             */
            _this.getIdPropertyName = function () {
                return config.idProperty || 'id';
            };

            /**
             * Create absolutely new model with default fields
             */
            _this.newModel = function () {
                var newModel = {};

                _.forEach(fields, function (field) {
                    if (!field.subResource) {
                        newModel[field.name] = field.defaultValue ? field.defaultValue : null;
                    }
                });

                return newModel;
            };

            /**
             * Get custom methods
             * @returns {Array.<Function>}
             */
            _this.getMethods = function () {
                return config.methods || {};
            };

            //endregion
        }

        return (ModelDefinition);

    })

;